import { v4 as uuidv4 } from 'uuid';

const getSessionId = () => {
  let sessionId = null;
  try {
    if (typeof localStorage !== 'undefined' && localStorage !== null) {
      sessionId = localStorage.getItem('session_id');
    }
  } catch (err) {
    // Access denied
  }

  if (!sessionId) {
    sessionId = uuidv4();
    try {
      if (typeof localStorage !== 'undefined' && localStorage !== null) {
        localStorage.setItem('session_id', sessionId);
      }
    } catch (err) {
      // Access denied
    }
  }
  return sessionId;
};

export default getSessionId;
